export const ENABLE_LOYALTY_STANDARD_OFFERS = true;
